// Completed output is best-effort local recovery; private browsing/storage eviction
// can make it unavailable. Supabase remains the authority for reviews and playback.
export interface CachedRoutine {
  fingerprint: string;
  blob: Blob;
  savedAt: number;
}
async function database(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open("bolly-routine-output", 1);
    req.onupgradeneeded = () => req.result.createObjectStore("outputs");
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}
export async function cachedRoutine(
  id: string,
  value?: CachedRoutine | null,
): Promise<CachedRoutine | undefined> {
  const db = await database();
  try {
    return await new Promise((resolve, reject) => {
      const transaction = db.transaction(
        "outputs",
        value === undefined ? "readonly" : "readwrite",
      );
      const store = transaction.objectStore("outputs");
      const req =
        value === undefined
          ? store.get(id)
          : value === null
            ? store.delete(id)
            : store.put(value, id);
      transaction.oncomplete = () =>
        resolve(value === undefined ? req.result : undefined);
      transaction.onerror = () => reject(transaction.error);
      transaction.onabort = () => reject(transaction.error);
    });
  } finally {
    db.close();
  }
}
